import ausNewInImage from "@/assets/images/search-new-in-aus.jpg";
import ausDressesImage from "@/assets/images/search-dresses-aus.jpg";
import ausMaxiDressesImage from "@/assets/images/search-maxi-dresses-aus.jpg";
import ausShopAllImage from "@/assets/images/search-shop-all-aus.jpg";

export function getSearchNavigationLinks(currencyCode) {
  if (String(currencyCode || "").toLowerCase() === "aud") {
    return searchNavigationLinksAus;
  }

  return searchNavigationLinks;
}

export const searchNavigationLinks = [
  {
    title: "New In",
    url: "/collections/new-in",
    badges: [],
    images: {
      blurry:
        "https://cdn.shopify.com/s/files/1/0942/9062/files/dresses_blurry.jpg?v=1755169613",
      smallMedia:
        "https://cdn.shopify.com/s/files/1/0942/9062/files/image_1_9fd203e2-884f-4401-99af-c03903ac895b.jpg?v=1792489967",
    },
  },
  {
    title: "Dresses",
    url: "/collections/dresses",
    badges: [],
    images: {
      blurry:
        "https://cdn.shopify.com/s/files/1/0942/9062/files/dresses_blurry.jpg?v=1755169613",
      smallMedia:
        "https://cdn.shopify.com/s/files/1/0942/9062/files/image_2_6ed48537-3078-4469-a014-8c65ddd8e613.jpg?v=1792489966",
    },
  },
  {
    title: "Separates",
    url: "/collections/separates",
    badges: [],
    images: {
      blurry:
        "https://cdn.shopify.com/s/files/1/0942/9062/files/wedding-guest_blurry.jpg?v=1755169614",
      smallMedia:
        "https://cdn.shopify.com/s/files/1/0942/9062/files/image_3_62f60ad1-f365-49a0-b9aa-edb2278c1457.jpg?v=1792489966",
    },
  },
  {
    title: "Shop All",
    url: "/collections/all",
    badges: [],
    images: {
      blurry:
        "https://cdn.shopify.com/s/files/1/0942/9062/files/wedding-guest_blurry.jpg?v=1755169614",
      smallMedia:
        "https://cdn.shopify.com/s/files/1/0942/9062/files/image_4_e71404fe-85b2-43fb-97b7-b4fca0a4241c.jpg?v=1792489966",
    },
  },
];

const searchNavigationLinksAus = [
  {
    title: "New In",
    url: "/collections/new-in",
    badges: [],
    images: {
      blurry: ausNewInImage,
      smallMedia: ausNewInImage,
    },
  },
  {
    title: "Dresses",
    url: "/collections/dresses",
    badges: [],
    images: {
      blurry: ausDressesImage,
      smallMedia: ausDressesImage,
    },
  },
  {
    title: "Maxi Dresses",
    url: "/collections/maxi-dresses",
    badges: [],
    images: {
      blurry: ausMaxiDressesImage,
      smallMedia: ausMaxiDressesImage,
    },
  },
  {
    title: "Shop All",
    url: "/collections/all",
    badges: [],
    images: {
      blurry: ausShopAllImage,
      smallMedia: ausShopAllImage,
    },
  },
];
